import React from 'react';
//components
//import Options from '../../../../buttons/Options';

//functions
//import { deleteMsg } from '../../../../functions/DeleteMsg';

const ShowAllDailyProjects = ({projects, profile}) => {
    return (
        <div>
            {projects?.map((project, index)=>{
                if(project.ProspectContent !== ""){
                return(
                    <div
                    key={index}
                    className="bg-gray-50 rounded-lg"
                    style={{marginBottom: '10px'}}
                    >
                        <div className="px-4 py-5 sm:p-6">
                            {/* <div style={{float: 'right'}}><Options project={project} profile={profile} deleteMsg={deleteMsg}/></div> */}
                            <p 
                            style={{
                                fontWeight: 700,
                                fontSize: 15,
                                marginBottom: '5px'
                            }}
                            >
                                {project?.ProspectName}
                            </p>
                            <p 
                            className="whitespace-pre-line my-3"
                            >
                                {project?.ProspectContent}
                            </p>
                        </div>
                    </div>
                )} else{
                    return null
                }
            })}
        </div>
    )
}

export default ShowAllDailyProjects
